<p-dialog header="Patient Migration Available" [visible]="true" modal="modal" [closable]="false"
    [dismissableMask]="false" appendTo="body">
    <div class="patients-migrate-container">
        @if (uiState.showMigrationOptions === true) {
        <div>
            <p>There is a patient migration available for your account (From the old version of PreMO). Do you wish to
                migrate these patients now? If not you can always go to your manage org page and migrate later.</p>
            <p-footer>
                <div class="flex flex-wrap gap-2 justify-content-end">
                    <button type="button" pButton label="Migrate Now" (click)="migrateData()"></button>
                    <button type="button" pButton label="Close & Dont Show Again" class="p-button-outlined"
                        (click)="skipDataMigration()"></button>
                    <button type="button" pButton label="Close" class="p-button-outlined"
                        (click)="closeDialog()"></button>
                </div>
            </p-footer>
        </div>
        }

        @if (uiState.isLoading === true) {
        <div class="flex justify-content-center align-items-center" style="min-height: 150px;">
            <p-progressSpinner ariaLabel="loading"></p-progressSpinner>
        </div>
        }


    </div>

</p-dialog>